module.exports = __webpack_public_path__ + "img/angle.8449bc1d.png";